import React from 'react';

const WaysCard = ({ title, description }) => {
    return (
        <div className='ways-card'>
            <article>
                <div></div>
                <h2>{title}</h2>
                <p>{description}</p>
            </article>
            <div className='artical-hover-before' />
        </div>
    );
};

export default WaysCard;